module.exports = __webpack_public_path__ + "img/footer-bg.a6d85c38.png";